import { useDispatch } from 'react-redux';
import { setSearchComponentEventView, setSearchComponentIsOpen, } from 'store/search/search-actions';
import { useGoogleMapsLibraries } from 'common/google-map-context';
import { useFindParkingSpotsButtonPartialStore, useShowLoader, } from '@spothero/search-component';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import { mapToSearchURLDateTimeValues } from 'pages/search/utils/date-utils';
import { handleSearchUpdates } from 'pages/search/utils/search-utils';
import { mapParkingTypes } from 'pages/search/utils/state-mapping-utils';
import { useHistory } from 'react-router';
export const useSearchUpdates = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { parkingType, parkingSubType, timezone, dates, startTime, endTime, startDate, endDate, monthlyStartDate, selectedSuggestion, errorType, } = useFindParkingSpotsButtonPartialStore();
    const closeSearchComponent = () => {
        dispatch(setSearchComponentIsOpen(false));
        dispatch(setSearchComponentEventView(null));
    };
    const { googleMapsLibraries } = useGoogleMapsLibraries();
    const { setIsLoaderShowing } = useShowLoader();
    const { destination, event, originalCitySlug, originalLatitude, originalLongitude, originalPageType, originalId, originalSearchString, parkingType: reduxParkingType, powerBookingSource: reduxPowerBookingSource, } = useReduxSearchState();
    const { parkingSubType: originalParkingSubType } = mapParkingTypes(reduxParkingType, reduxPowerBookingSource);
    return async () => {
        setIsLoaderShowing(true);
        // Edge case: User closed the modals with Power Booking validation errors
        // We refresh the browser to clear the error state
        if (!selectedSuggestion ||
            (parkingSubType === 'power_booking' && errorType)) {
            setIsLoaderShowing(false);
            window.location.reload();
            return;
        }
        const dateTimeValues = mapToSearchURLDateTimeValues({
            parkingType,
            parkingSubType,
            dateRangeStartDate: startDate,
            dateRangeEndDate: endDate,
            monthlyStartDate,
            powerBookingDates: dates,
            powerBookingStartTime: startTime,
            powerBookingEndTime: endTime,
            timezone,
        });
        await handleSearchUpdates({
            destination,
            event,
            // @ts-expect-error - this is a type error inside the search component - need to cut ticket
            selectedSuggestion,
            parkingSubType,
            dateTimeValues,
            timezone,
            originalCitySlug,
            originalPageType,
            originalId,
            originalSearchString,
            originalLatitude,
            originalLongitude,
            originalParkingSubType,
            googleMapsLibraries,
            dispatch,
            history,
            onClose: () => {
                setIsLoaderShowing(false);
                closeSearchComponent();
            },
        });
    };
};
/**
 * This function is used to apply search updates when a user selects a suggestion from the search component.
 * It is used in callbacks where we are not able to use hooks.
 * The logic is similar to the useSearchUpdates hook.
 */
export const applySearchUpdates = async ({ selectedSuggestion, findParkingPartialStore, reduxSearchState, googleMapsLibraries, setIsLoaderShowing, closeSearchComponent, dispatch, history, }) => {
    const { parkingType, parkingSubType, timezone, dates, startTime, endTime, startDate, endDate, monthlyStartDate, errorType, } = findParkingPartialStore;
    const { destination, event, originalCitySlug, originalLatitude, originalLongitude, originalPageType, originalId, originalSearchString, parkingType: reduxParkingType, powerBookingSource: reduxPowerBookingSource, } = reduxSearchState;
    const { parkingSubType: originalParkingSubType } = mapParkingTypes(reduxParkingType, reduxPowerBookingSource);
    if (!selectedSuggestion ||
        (parkingSubType === 'power_booking' && errorType)) {
        setIsLoaderShowing(false);
        window.location.reload();
        return;
    }
    const dateTimeValues = mapToSearchURLDateTimeValues({
        parkingType,
        parkingSubType,
        dateRangeStartDate: startDate,
        dateRangeEndDate: endDate,
        monthlyStartDate,
        powerBookingDates: dates,
        powerBookingStartTime: startTime,
        powerBookingEndTime: endTime,
        timezone,
    });
    await handleSearchUpdates({
        destination,
        event,
        selectedSuggestion,
        parkingSubType,
        dateTimeValues,
        timezone,
        originalCitySlug,
        originalPageType,
        originalId,
        originalSearchString,
        originalLatitude,
        originalLongitude,
        originalParkingSubType,
        googleMapsLibraries,
        dispatch,
        history,
        onClose: () => {
            setIsLoaderShowing(false);
            closeSearchComponent();
        },
    });
};
